export default __webpack_public_path__ + "static/media/redo_grey.1de4ca44.svg";